import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGalleryType, IGalleryTypeInitialState } from "./gallerytypeModel";
import {
  ActiveInactiveGalleryType,
  createGalleryType,
  deleteGalleryType,
  getAllActiveGalleryType,
  getAllGalleryType,
  getGalleryTypeByID,
  GalleryTypeImageUpload,
  updateGalleryType,
} from "./services/gallerytype.services";

const initialState: IGalleryTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  GalleryTypeID: null,
  GalleryTypeList: [],
  GalleryTypeDetail: {
    ID: null,
    GalleryType: "",
    
    IsActive: 1,
  },
};

const gallerytypeSlice = createSlice({
  name: "gallerytype",
  initialState,
  reducers: {
    clearGalleryTypeDetails: (state) => {
      state.GalleryTypeDetail = initialState.GalleryTypeDetail;
    },
    setGalleryTypeID: (state, action) => {
      state.GalleryTypeID = action.payload;
    },
    clearGalleryTypeID: (state) => {
      state.GalleryTypeID = initialState.GalleryTypeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGalleryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllGalleryType.fulfilled,
      (state, action: PayloadAction<IGalleryType[]>) => {
        state.loading = false;
        state.GalleryTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllGalleryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GalleryTypeList = [];
    });
    builder.addCase(createGalleryType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createGalleryType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createGalleryType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateGalleryType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateGalleryType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateGalleryType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteGalleryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGalleryType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGalleryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGalleryTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getGalleryTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.GalleryTypeDetail = action.payload;
    });
    builder.addCase(getGalleryTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.GalleryTypeDetail = initialState.GalleryTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveGalleryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveGalleryType.fulfilled,
      (state, action: PayloadAction<IGalleryType[]>) => {
        state.loading = false;
        state.GalleryTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveGalleryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GalleryTypeList = [];
    });
    builder.addCase(ActiveInactiveGalleryType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveGalleryType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveGalleryType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(GalleryTypeImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(GalleryTypeImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(GalleryTypeImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearGalleryTypeDetails, clearGalleryTypeID, setGalleryTypeID } =
  gallerytypeSlice.actions;
export default gallerytypeSlice.reducer;
